// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2icLZ","title":"styles_title__3goIB"};